module.exports = __webpack_public_path__ + "static/10-4d62b1a01209be843cda0bec5f0339d1.jpg";